export const sendAnalytics = (event, info = '') => {
    let urlAnalytics;
    let appClient = "bmw";

    //PRE
    if (window.location.href.indexOf("dev.") > 1) {
      urlAnalytics = "https://dev.apibank.mini.es/rest/analytics_input.php";
      if (appClient === "bmw") {
        urlAnalytics = "https://dev.apibank.bmw.es/rest/analytics_input.php";
      }

      //LOCALHOST
    } else if (window.location.href.indexOf("localhost") > 1) {
      urlAnalytics = "https://dev.apibank.mini.es/rest/analytics_input.php";
      if (appClient === "bmw") {
        urlAnalytics = "https://dev.apibank.bmw.es/rest/analytics_input.php";
      }

      //PRO
    } else {
      urlAnalytics = "https://apibank.mini.es/rest/analytics_input.php";
      if (appClient === "bmw") {
        urlAnalytics = "https://apibank.bmw.es/rest/analytics_input.php";
      }
    }

    let data = {};
    data.event = event;
    data.info = info;
    data.origin = "postventa-calculator";

    fetch(urlAnalytics, {
      method: "POST", // Método HTTP para la solicitud
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data), // Convierte el objeto `datos` a una cadena JSON
    })
      .then((response) => response.text()) // Convierte la respuesta recibida a texto
      .then((texto) => console.log(texto)) // Muestra el texto de respuesta en la consola
      .catch((error) => console.error("Error:", error));
  }